import theme from "@/theme";

export const styles = {
  container: {
    backgroundColor: "#FFFFFF",
    margin: "0px",
    overflow: "hidden",
  },
  header: {
    height: "54px",
    backgroundColor: "#FFFFFF",
    marginBottom: "1px",
    padding: "15px 20px",
    gup: "20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  starButton: {
    color: "#007bff",
  },
  tabsBox: {
    display: "flex",
    gap: 3,
  },
  tabItem: (active: boolean) => ({
    cursor: "pointer",
    color: active ? theme.palette.custom.mainBlue : "#4f5b67",
    borderBottom: active ? `2px solid ${theme.palette.custom.mainBlue}` : "none",
    pb: "4px",
    fontWeight: active ? 600 : 500,
  }),
  wallet: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    backgroundColor: "#F5F5F5",
  },

  wrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
  },
};
